import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from './Theme';
import { Product } from 'connect-dot-com-ui/consts';
import MarketingHubLogo from './Icons/MarketingHubLogo';
import OpsHubLogo from './Icons/OpsHubLogo';
import ServiceHubLogo from './Icons/ServiceHubLogo';
import SalesHubLogo from './Icons/SalesHubLogo';
import CMSHubLogo from './Icons/CMSHubLogo';
const ProductIcons = {
  [Product.Marketing]: /*#__PURE__*/_jsx(MarketingHubLogo, {
    size: 24
  }),
  [Product.Operations]: /*#__PURE__*/_jsx(OpsHubLogo, {
    size: 24
  }),
  [Product.Service]: /*#__PURE__*/_jsx(ServiceHubLogo, {
    size: 24
  }),
  [Product.Sales]: /*#__PURE__*/_jsx(SalesHubLogo, {
    size: 24,
    style: {
      position: 'relative',
      top: -1
    }
  }),
  [Product.CMS]: /*#__PURE__*/_jsx(CMSHubLogo, {
    size: 24,
    style: {
      position: 'relative',
      top: -1
    }
  })
};
const TagWrapper = styled.div.withConfig({
  displayName: "ProductTag__TagWrapper",
  componentId: "sc-1mh5x3l-0"
})(["display:", ";align-items:center;&:not(:last-child){margin-bottom:12px;}"], props => props.$inline ? 'inline-flex' : 'flex');

const ProductTag = ({
  product,
  inline,
  className
}) => {
  return /*#__PURE__*/_jsxs(TagWrapper, {
    className: className,
    $inline: inline,
    "data-test-id": "product-tag",
    children: [ProductIcons[product], /*#__PURE__*/_jsx(FormattedMessage, {
      className: "m-left-2",
      message: `connectDotCom.hubs.${product}`
    })]
  });
};

export default ProductTag;